const COMMENT_HREF_RE = /^#comments\/([^/]+)\/(\d+)$/
const SCROLL_POLL_INTERVAL_MS = 200
const SCROLL_POLL_MAX_ATTEMPTS = 30
const NAV_DELAY_MS = 300

function navigateToCommentsTab() {
  const currentHash = window.location.hash || ''
  if (currentHash.startsWith('#comments')) return false

  const topHash = currentHash.split('/')[0]
  const newHash = topHash ? currentHash.replace(topHash, '#comments') : '#comments'
  window.location.hash = newHash
  return true
}

function findTarget(responseId: string, questionId: string): Element | null {
  return (
    document.querySelector(`[data-id="Response${responseId}_Question${questionId}"]`) ??
    document.querySelector(`[data-id="Response_${responseId}"]`)
  )
}

function scrollToResponse(responseId: string, questionId: string) {
  let attempts = 0
  const tick = () => {
    const target = findTarget(responseId, questionId)
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      return
    }
    if (++attempts < SCROLL_POLL_MAX_ATTEMPTS) {
      setTimeout(tick, SCROLL_POLL_INTERVAL_MS)
    }
  }
  tick()
}

export default function CommentLink({ href, children }: { href: string; children: React.ReactNode }) {
  const match = href.match(COMMENT_HREF_RE)
  const questionId = match?.[1]
  const responseId = match?.[2]

  return (
    <a
      href={href}
      onClick={event => {
        event.preventDefault()
        event.stopPropagation()
        if (!questionId || !responseId) return

        const navigated = navigateToCommentsTab()
        setTimeout(() => scrollToResponse(responseId, questionId), navigated ? NAV_DELAY_MS : 0)
      }}
    >
      {children}
    </a>
  )
}
